import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Importing_and_exporting extends PureComponent {
  render() {
    return (
      <div className="row" id="Importing_and_exporting">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Importing and Exporting</h2>
              <p>
                The model import/export tool is your friend. Before making any
                changes or testing new modules, we advise you to export your
                current model in full. This will backup your subscriptions and
                any customizations at a company group level (but not user) and
                create a JSON file that can be imported later or moved to a new
                account.
              </p>
              <p>
                Because Nexoid allows a month free usage, we would encourage you
                to register temporary new accounts when testing any complex
                module customization. We will automatically delete them after
                two months if no payment methods are provided. So if you're
                working on a complex module, we suggest you regularly backup
                using the export tool.
              </p>
              <p>
                By exporting your module, you can see the full JSON of any
                subscriptions. This can be useful for beginners when you're
                unsure where and at what level different interface components
                live.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Importing_and_exporting;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Importing_and_exporting.js